// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"868":"726dead0","2977":"0aa0a711","4961":"726dead0","5923":"5261403b","7014":"5261403b","7320":"65d07f61"}[chunkId] + ".chunk.css";
};